import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogUiRedesign/DialogHeader';

import styles from './FailedPOCView.module.scss';

interface FailedPOCViewProps {
  onClose: () => void;
  onContactSupport: () => void;
  onTryAgain: () => void;
}

export function FailedPOCView(props: FailedPOCViewProps) {
  const { onClose, onTryAgain, onContactSupport } = props;
  const { t } = useTranslation();
  return createPortal(
    <div className={styles.parent}>
      <div className={classNames(styles.dialog)}>
        <DialogHeader title={t('poc.redemptionIssue')} titleClassName={styles.title} onClose={onClose} />
        <DialogContent>
          <div className={styles.textWrapper}>
            <span className={styles.textBig}>{t('poc.weWereUnableToAuthenticate')}</span>
            <span className={styles.textSmall}>{t('poc.pleaseNote')}</span>
          </div>
          <div className={styles.buttonsWrapper}>
            <Button btnType="main" className={styles.btn} onClick={onTryAgain}>
              {t('poc.tryAgain')}
            </Button>
            <Button btnType="purple" className={styles.btn} onClick={onContactSupport}>
              {t('common.contactSupport')}
            </Button>
          </div>
        </DialogContent>
      </div>
    </div>,
    document.body,
  );
}
